export const ADMINISTRACION_USUARIOS = "https://api-usuarios.cydingenieria.com";
export const BACKEND_PORTAFOLIO = "https://api-portafolio.cydingenieria.com";
export const BACKEND = "https://api-micyd.micyd.pe";
export const LOGIN = "https://account.micyd.pe";
export const PORTAFOLIO = "https://portafolio.cydingenieria.com";
export const REDIRECT_BASE = "https://api-usuarios.micyd.pe/login";
export const DOMINIO_MICYD = "https://micyd.cl/";
export const STORAGE = "https://storage.cydingenieria.com";
export const SDA = "https://sda.cydingenieria.com";
export const ACTIVOS = "https://activos.cydingenieria.com";

export const CANAL_DENUNCIAS_ECONOMICAS =
  "https://docs.google.com/forms/d/e/1FAIpQLSdiAXU6tsucBe9JEdIm8Kfljwzbh2GcoXmAeqmaVCD8MtllEg/viewform";
export const CANAL_DENUNCIAS_SEXUALES =
  "https://docs.google.com/forms/d/e/1FAIpQLSeSCyhJMTb5d2lvBFRMp1Nn4OXwXaT_SCf1ukpBAWeOBu0Vrg/viewform";
